export default "__VITE_ASSET__Ugf2WGcP__"